'use client'

import React, { memo } from 'react'

interface CableElementProps {
  // Coordonnées du câble
  x1: number
  y1: number
  x2: number
  y2: number
  // Couleur
  color: string
  // Identifiant unique pour l'animation
  linkId: string
  // Type de câble (data = avec cercle de connexion, power = sans)
  type?: 'data' | 'power'
  // Props optionnelles
  strokeWidth?: string
  opacity?: string
}

const CableElement = memo<CableElementProps>(({
  x1,
  y1,
  x2,
  y2,
  color,
  linkId,
  type = 'data',
  strokeWidth = '1.5',
  opacity = '0.6'
}) => {
  return (
    <g>
      {/* Animation CSS pour le câble */}
      <defs>
        <style>{`
          @keyframes dash-flow-${linkId} {
            to {
              stroke-dashoffset: -20;
            }
          }
          .animated-link-${linkId} {
            animation: dash-flow-${linkId} 1s linear infinite;
          }
        `}</style>
      </defs>
      
      {/* Ligne du câble avec animation */}
      <line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray="5,5"
        fill="none"
        opacity={opacity}
        className={`animated-link-${linkId}`}
      />
      
      {/* Cercle de connexion (uniquement pour les câbles data) */}
      {type === 'data' && (
        <circle
          cx={x1}
          cy={y1}
          r="3"
          fill={color}
          stroke="white"
          strokeWidth="1"
        />
      )}
    </g>
  )
}, (prevProps, nextProps) => {
  // Comparaison personnalisée pour éviter les re-renders inutiles
  return (
    prevProps.x1 === nextProps.x1 &&
    prevProps.y1 === nextProps.y1 &&
    prevProps.x2 === nextProps.x2 &&
    prevProps.y2 === nextProps.y2 &&
    prevProps.color === nextProps.color &&
    prevProps.linkId === nextProps.linkId &&
    prevProps.type === nextProps.type &&
    prevProps.strokeWidth === nextProps.strokeWidth &&
    prevProps.opacity === nextProps.opacity
  )
})

CableElement.displayName = 'CableElement'

export default CableElement

